<template>
  <div>
    <div class="xc-page xc-page-sandwich">
      <div class="xc-page-main">
        <!-- 面包屑 -->
        <div class="xc-breadcrumb">
          <router-link :to="$config.adminPath + '/device'">终端管理</router-link>
          <router-link :to="$config.adminPath + '/device/apk'">面板APK</router-link>
          <a>手动升级</a>
        </div>
        <xc-step :step-value="stepValue"></xc-step>
        <!-- 选择终端 -->

        <div class="xc-row xc-s-flex" style="overflow: auto" v-if="currentStep == 0">
          <div class="xc-card xc-s-df">
            <div class="device-group">
              <div class="xc-card-header">
                <div class="xc-card-title">
                  门店列表
                  <!-- <span>点击右键操作更多</span> -->
                </div>
              </div>
              <!-- 树形目录 -->
              <div class="tree xc-s-p" style="overflow: auto;" >
                <el-tree 
                  :data="stores" 
                  :props="defaultProps" 
                  node-key="storeId" 
                  show-checkbox
                  ref="storeTree"
                  :default-expanded-keys="[0]" 
                  @check-change="selectFunc"
                >
                </el-tree>
              </div>
            </div>
            <!-- 隐藏的数据 -->
            <span style="display:none;">{{ selectCount }}</span>
            <!--  带滚动条表格 -->
            <div class="xc-row xc-s-flex" style="overflow: auto;">
              <div class="xc-card">
                <div class="xc-card-content">
                  <form class="xc-form">
                    <div class="xc-form-inline">
                      <xc-form-item label="面板名称">
                        <input type="text" maxlength="255" class="xc-input" placeholder="请输入面板名称"
                          v-model="search.panelName">
                      </xc-form-item>
                      <xc-form-item label="在线状态">
                        <select class="xc-select" v-model="search.panelStatus">
                          <option value=''>全部</option>
                          <option value='0'>在线</option>
                          <option value='1'>离线</option>
                        </select>
                      </xc-form-item>
                      <div class="form-item-group" style="margin-right:20px;">
                        <select class="xc-select" v-model="searchType" style="width:100px;margin-right:10px">
                          <option value="mac">mac</option>
                        </select>
                        <input type="text" maxlength="255" class="xc-input" placeholder="请输入" v-if="searchType == 'mac'"
                          v-model="search.panelMac">
                      </div>
                      <div class="xc-btn-group">
                        <button type="submit" class="xc-btn xc-btn-primary" @click.prevent="getList()">查询</button>
                      </div>
                    </div>

                    <div class="xc-form-inline">
                      <xc-form-item class="xc-s-flex">

                      </xc-form-item>
                    </div>
                  </form>
                  <!-- 带滚动条的表格 -->
                  <div class="xc-row-scroll">
                    <table class="xc-table">
                      <thead>
                        <tr>
                          <th>
                            <input type="checkbox" class="xc-checkbox" :checked="checkAll" @change="checkAllChange">
                          </th>
                          <th>面板名称</th>
                          <th>面板IP</th>
                          <th>面板MAC</th>
                          <th>门店名称</th>
                          <th>房间名称</th>
                          <th>在线状态</th>
                          <th>面板类型</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="list && list.length > 0">
                          <tr v-for="(item, key) in list" :key="key">
                            <td style="width: 45px;">
                              <input type="checkbox" class="xc-checkbox" :checked="selectDevice[item.panelCode]"
                                @change="deviceChecked(item)">
                            </td>
                            <td>{{ item.panelName }}</td>
                            <td>{{ item.externalIp }}</td>
                            <td>{{ item.panelMac }}</td>
                            <td>{{ item.storeName }}</td>
                            <td>{{ item.roomName }}</td>
                            <td>{{ item.panelStatus | getPanelStatus }}</td>
                            <td>{{ item.model }}</td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>
                            <td colspan="9" class="xc-s-tac">请选择终端</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  终端确认 -->
        <div class="xc-row xc-s-flex" style="overflow: hidden;" v-if="currentStep == 1">
          <div class="xc-card">
            <div class="xc-card-content">
              <div class="xc-form-inline xc-form-inline-resete">
                <div>
                  APK名称：{{ apkDetail.apkName }}，升级版本：{{ apkDetail.versionName }}
                </div>
                <div>共{{ selectCount }}条数据预览、共{{ groupCount }}组、{{ selectCount }}终端、经办人：{{ apkDetail.uploader }}</div>
              </div>
              <!-- 带滚动条的表格 -->
              <div class="xc-row-scroll">
                <table class="xc-table">
                  <thead>
                    <tr>
                     <th>面板名称</th>
                    <th>面板IP</th>
                    <th>面板MAC</th>
                    <th>门店名称</th>
                    <th>房间名称</th>
                    <th>在线状态</th>
                    <th>面板类型</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="selectDeviceArray && selectDeviceArray.length">
                      <tr v-for="(item, key) in selectDeviceArray" :key="key">
                        <td>{{ item.panelName }}</td>
                        <td>{{ item.externalIp }}</td>
                        <td>{{ item.panelMac }}</td>
                        <td>{{ item.storeName }}</td>
                        <td>{{ item.roomName }}</td>
                        <td>{{ item.panelStatus | getPanelStatus }}</td>
                        <td>{{ item.model }}</td>
                        <td class="xc-link">
                          <a @click="deviceChecked(item)">删除</a>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="9 " class="xc-s-tac">暂无数据</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="xc-row xc-s-flex" style="overflow: hidden;" v-if="currentStep == 2">
          <div class="xc-card xc-device-apk">
            <div class="xc-card-content xc-device-apk-complete">
              <div class="xc-form-inline">
                <div>
                  <img src="../assets/success.png" v-if="upSuccess">
                  <img src="../assets/fail.png" v-else>
                  <div class="xc-device-apk-success">{{ upSuccess ? '升级成功!' : '升级失败!' }}</div>
                  <div>共{{ selectCount }}条数据，成功下发{{ groupCount }}分组{{ selectCount }}个设备</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <!-- 固低栏 -->
      <div class="xc-page-footer" style="z-index: 9;">
        <div class="xc-btn-group">
          <div class="xc-btn xc-btn-default" @click="preStep" v-if="currentStep == 1">上一步</div>
          <div class="xc-btn xc-btn-primary" @click="nextStep" v-if="currentStep == 0">下一步</div>
          <div class="xc-btn xc-btn-primary" @click="nextStep" v-if="currentStep == 1">升级</div>
          <router-link class="xc-btn xc-btn-primary" :to="$config.adminPath + '/device/panel/apk'"
            v-if="currentStep == 2">完成</router-link>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import devicePanelApi from '@/api/devicePanel'
import houseApi from "@/api/systemHouse"
export default {
  name: 'deviceApkUpgrade',
  data() {
    return {
      currentStep: 0,
      stepValue: [
        {
          text: "选择终端",
          active: true,

        },
        {
          text: "终端确认"
        },
        {
          text: "升级完成"
        }
      ],

      // 列表
      list: [],

      // 终端分组
      deviceGroups: [],

      // 弹出窗
      modalName: null,

      // 搜索类型
      searchType: 'mac',

      // 搜索
      search: {
        panelStatus: '',
      },

      // 选择的终端
      selectDevice: {},

      groupCount: 0,

      // apk升级详情
      apkDetail: {},

      // 是否升级成功
      upSuccess: false,
      stores:[], //门店列表数据
        defaultProps: {
        children: 'children',
        label: 'storeName'
      },
    };
  },

  created() {
    // deviceApi.getDeviceGroup().then((v) => {
    //   this.deviceGroups = v.data;
    // })

    devicePanelApi.getApkById({params:{ panelApkId: this.$route.params.panelApkId }}).then((v) => {
      this.apkDetail = v.data;
      // this.getList();
    })
    this.getStoreList();
  },
  filters: {
    getPanelStatus: function (value) {
      if (value == 0) {
        return "在线"
      }
      return "离线";
    }
  },
  methods: {
       //获取门店列表数据
    getStoreList() {
        var _this = this;
        houseApi.getStoreSelectList().then(function (ret) {
          _this.stores.push({storeId: 0, storeName: `全部(${ret.data.length})`,children:ret.data})
          _this.getList()

        }).catch(function (error) {
            console.log(error)
        });
    },
    // 树形点击文字的回调
     selectFunc() {
       const ckeckList =  this.$refs.storeTree.getCheckedKeys()
        this.search.storeIds = ckeckList.join(',');

        if (this.search.storeIds == '') {
          this.selectDevice = {};
          return;
        }
        let checkAll = false
        if(ckeckList.length == this.stores.length){
          checkAll = true;
        }
        this.getList(checkAll);
      },
    // 初始化数据
    getList(checkAll) {
      // 默认搜索的数据
      const search = {
        pageNum: 1,
        pageSize: 0,
        ...this.search
      };

      devicePanelApi.getPanelListByStoreId({params:search}).then(ret => {

        const list = ret.data;
        // 全选
        // if (checkAll) {
        //   const selectDevice = {
        //     ...this.selectDevice,
        //   }

        //   list.map(item => {
        //     selectDevice[item.panelCode] = item;
        //   })

        //   this.selectDevice = selectDevice;
        // }


        this.list = list;
      })

    },

    // 下一步
    nextStep() {
      let stepLen = this.stepValue.length;
      let cur = this.currentStep;

      const next = () => {
        if (cur < stepLen - 1) {
          this.$set(this.stepValue[cur + 1], "active", true);
        }

        this.$set(this.stepValue[cur], "complete", true);

        // if (cur == stepLen - 2) {
        //     this.$set(this.stepValue[cur + 1], "complete", true);
        // }

        this.currentStep++;
      }

      if (cur == 0) {
        if (!this.selectCount) return this.$message.error('请选择需要升级的终端');
      }
      else if (cur == 1) {
        const panelIds = this.selectDeviceArray.map((v) => {
          return v.panelId;
        })

        devicePanelApi.panelUpgrade({
          panelIds: panelIds.join(','),
          panelApkId: this.$route.params.panelApkId,
        }).then(() => {
          this.upSuccess = true
          next();
        })

        return;
      }

      if (cur >= stepLen) {
        // 结束操作
        return;
      }

      next();

    },

    // 上一步
    preStep() {
      let stepLen = this.stepValue.length;
      let cur = this.currentStep;
      if (cur <= 0) {
        // 结束操作
        return;
      }
      if (cur > -1 && cur < stepLen) {
        this.$set(this.stepValue[cur], "active", false);
      }

      this.$set(this.stepValue[cur - 1], "complete", false);
      this.currentStep--;
    },

    // 设备选中
    deviceChecked(item) {
      const selectDevice = {
        ...this.selectDevice,
      }

      if (selectDevice[item.panelCode]) {
        delete selectDevice[item.panelCode];
      } else {
        selectDevice[item.panelCode] = item;
      }

      this.selectDevice = selectDevice;
    },


    checkAllChange() {

      const selectDevice = {
        ...this.selectDevice,
      }

      this.list.map(item => {
        if (this.checkAll) {
          delete selectDevice[item.panelCode];
        } else {
          selectDevice[item.panelCode] = item;
        }
      })

      this.selectDevice = selectDevice;
    }

  },
  computed: {
    // 是否全选
    checkAll() {
      if (Object.keys(this.selectDevice).length == 0 || this.list.length == 0) {
        return false;
      }

      // 判断是否有没有选中的数据
      let notAll = this.list.some((item) => {
        return this.selectDevice[item.panelCode] == undefined;
      })

      return notAll ? false : true;
    },

    selectCount() {
      const selectCount1 = Object.keys(this.selectDevice).length;

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.stepValue[0].text = `选择终端(${selectCount1})`;

      return selectCount1;
    },


    selectDeviceArray() {

      // 计算一下分组数量
      const groupCount = {};

      const selectDeviceArray = Object.keys(this.selectDevice).map(key => {

        const item = this.selectDevice[key];

        groupCount[item.groupName] = item.groupName;

        return item;
      })

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.groupCount = Object.keys(groupCount).length;

      return selectDeviceArray;
    }
  },
};
</script>

<style scoped lang="scss">
.xc-device-apk {
  display: flex;
  align-items: center;
  justify-content: center;
}

.xc-device-apk-complete {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.xc-device-apk-success {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 2px;
}

.xc-form-inline-resete {
  display: block;
}
</style>
